const FileCategoriesEnum = {
  ACTION_CODE_CONDITION: 'actionCodeConditions',
  WERTPAPIERINFORMATIONSBLATT: 'bond-wertpapierinformationsblatt',
  WERTPAPIERPROSPEKT: 'bond-wertpapierprospekt',
  BASISINFORMATIONSBLATT: 'bond-basisinformationsblatt',
  KUNDENINFORMATIONEN: 'kundeninformationen',
  ANGEBOTSBEDINGUNG: 'bond-angebotsbedingungen',
  CHECKOUT_DOCUMENTS: 'checkout-documents',
  AGB: 'agb',
  VERMOEGENSINFORMATIONSBLATT: 'loan-vermoegensinformationsblatt',
  GESETZLICHEPFLICHTANGABEN: 'loan-gesetzliche-pflichtangaben',
  ANGEBOTSUNTERLAGEN: 'loan-angebotsunterlagen',
  VERBRAUCHERINFORMATIONEN: 'verbraucherinformationen',
  KOSTEN_NEBENKOSTEN: 'kosten-nebenkosten',
  EXPOSE: 'expose',
  ZEICHNUNGSSCHEIN: 'zeichnungsschein',
  ECSP_ANLAGEBASISINFORMATIONSBLATT: 'ecsp-anlagebasisinformationsblatt',
  ECSP_ANGEBOTSUNTERLAGEN: 'ecsp-angebotsunterlagen',
  ECSP_GESETZLICHEPFLICHTANGABEN: 'ecsp-gesetzliche-pflichtangaben',
  ECSP_KOSTENINFORMATIONEN: 'ecsp-kosteninformationen',
  ECSP_BEDENKZEIT: 'ecsp-vorvertragliche-bedenkzeit',
  ECSP_AGB: 'ecsp-agb',
};

const CommonFileCategoriesEnum = {
  ANGEBOTSBEDINGUNG: FileCategoriesEnum.ANGEBOTSBEDINGUNG,
  KOSTEN_NEBENKOSTEN: FileCategoriesEnum.KOSTEN_NEBENKOSTEN,
  VERBRAUCHERINFORMATIONEN: FileCategoriesEnum.VERBRAUCHERINFORMATIONEN,
  CHECKOUT_DOCUMENTS: FileCategoriesEnum.CHECKOUT_DOCUMENTS,
};

export const FileCategoriesForBondWibEnum = {
  ...CommonFileCategoriesEnum,
  WERTPAPIERINFORMATIONSBLATT: FileCategoriesEnum.WERTPAPIERINFORMATIONSBLATT,
};

export const FileCategoriesForBondFullEnum = {
  ...CommonFileCategoriesEnum,
  WERTPAPIERPROSPEKT: FileCategoriesEnum.WERTPAPIERPROSPEKT,
};

export const FileCategoriesForBondPriipEnum = {
  ...CommonFileCategoriesEnum,
  BASISINFORMATIONSBLATT: FileCategoriesEnum.BASISINFORMATIONSBLATT,
};

export const FileCategoriesForEcspEnum = {
  ECSP_ANLAGEBASISINFORMATIONSBLATT: FileCategoriesEnum.ECSP_ANLAGEBASISINFORMATIONSBLATT,
  ECSP_ANGEBOTSUNTERLAGEN: FileCategoriesEnum.ECSP_ANGEBOTSUNTERLAGEN,
  ECSP_GESETZLICHEPFLICHTANGABEN: FileCategoriesEnum.ECSP_GESETZLICHEPFLICHTANGABEN,
  ECSP_KOSTENINFORMATIONEN: FileCategoriesEnum.ECSP_KOSTENINFORMATIONEN,
  ECSP_BEDENKZEIT: FileCategoriesEnum.ECSP_BEDENKZEIT,
  ECSP_AGB: FileCategoriesEnum.ECSP_AGB,
};

Object.freeze(FileCategoriesEnum);

export default FileCategoriesEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/FileCategories.js